import { Button, Modal } from '@basqet-dashboard/common/components';
import PropTypes from 'prop-types';
import React from 'react';

const RestartOnboardingModal = ({ isOpen, onClose, onRestart, isLoading }) => {
  if (!isOpen) return null;

  return (
    <Modal header={{ name: 'Need to Restart', cursive: 'Onboarding?' }} onModalClose={onClose}>
      <p className="modal__text">
        If you go back, we&apos;ll clear your current progress so you can start fresh and select a
        new onboarding path (e.g., freelancer, CNF, or CFI). This cannot be undone.
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>
        <Button isFull onClick={onRestart} isLoading={isLoading}>
          Erase and start over
        </Button>
        <Button isFull variant="outline" onClick={onClose}>
          Keep editing
        </Button>
      </div>
    </Modal>
  );
};

RestartOnboardingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRestart: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};

export { RestartOnboardingModal };
